import { useRuntimeConfig } from "#app";
import { createConsola } from "consola";
const logger = createConsola({
  defaults: {
    tag: "\u{1F4AC} msg"
  }
});
export const useDebugLogger = () => {
  const config = useRuntimeConfig();
  const isDebugMode = config.public?.nuxtMessagingDebug || false;
  return {
    log: (...args) => {
      if (isDebugMode) logger.info(...args);
    },
    error: (...args) => {
      if (isDebugMode) logger.error(...args);
    }
  };
};
